import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { formatDate } from '../lib/format';
import MemberLayout from '../components/MemberLayout';
import { Card } from '../components/ui/card';
import { Progress } from '../components/ui/progress';
import { Award } from 'lucide-react';

export default function Certificate() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get('/academy/certificate').then(r => setData(r.data)).catch(()=>{}); }, []);

  if (!data) return <MemberLayout><div className="h-64 flex items-center justify-center text-muted-foreground">Memuat...</div></MemberLayout>;

  return (
    <MemberLayout>
      <h1 className="font-display text-2xl sm:text-3xl font-bold mb-6">Certificate of Completion</h1>
      {!data.eligible ? (
        <Card className="p-6">
          <p className="text-muted-foreground">Selesaikan seluruh lesson (100%) dan capai skor quiz minimal {data.required?.quiz_score}% untuk membuka sertifikat.</p>
          <div className="mt-4 space-y-3">
            <div><div className="flex justify-between text-sm mb-1"><span>Progress Lesson</span><span>{data.progress.percent}%</span></div><Progress value={data.progress.percent} className="h-2" /></div>
            <div><div className="flex justify-between text-sm mb-1"><span>Skor Quiz</span><span>{data.progress.quiz_score}%</span></div><Progress value={data.progress.quiz_score} className="h-2" /></div>
          </div>
        </Card>
      ) : (
        <div data-testid="certificate-card" className="relative rounded-2xl border-4 border-[hsl(var(--brand-gold))] bg-card p-8 sm:p-12 text-center shadow-lg">
          <div className="absolute inset-3 border border-[hsl(var(--brand-gold)/0.4)] rounded-xl pointer-events-none" />
          <Award className="h-14 w-14 mx-auto text-[hsl(var(--brand-gold))]" />
          <div className="mt-4 text-sm uppercase tracking-widest text-muted-foreground">Certificate of Completion</div>
          <h2 className="font-display text-2xl font-bold mt-2">Gold Trading Academy</h2>
          <div className="mt-6 text-muted-foreground text-sm">Diberikan kepada</div>
          <div className="font-display text-3xl font-bold mt-1">{data.certificate.name}</div>
          <p className="mt-4 text-sm text-muted-foreground max-w-md mx-auto">Telah menyelesaikan kurikulum Gold Trading Academy dengan skor quiz {data.certificate.quiz_score}%.</p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-6 text-sm">
            <div><div className="text-muted-foreground">Tanggal</div><div className="font-medium">{formatDate(data.certificate.completion_date)}</div></div>
            <div><div className="text-muted-foreground">Nomor Sertifikat</div><div className="font-medium font-mono">{data.certificate.certificate_number}</div></div>
          </div>
          <p className="text-xs text-muted-foreground mt-8">Sertifikat ini menyatakan penyelesaian kursus edukasi dan bukan lisensi/sertifikasi profesi trader.</p>
        </div>
      )}
    </MemberLayout>
  );
}
